import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '@atoms/button/button.component';
import { ModalLayoutComponent } from '@organisms/modal-layout/modal-layout.component';

@Component({
  selector: 'iahoy-unsaved-changes-modal',
  imports: [ButtonComponent, ModalLayoutComponent],
  templateUrl: './unsaved-changes-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unsaved-changes-modal.component.scss']
})
export class UnsavedChangesModalComponent {
  private dialogRef = inject(MatDialogRef<UnsavedChangesModalComponent>);

  leavePage(): void {
    this.dialogRef.close(true);
  }

  stayOnPage(): void {
    this.dialogRef.close(false);
  }
}
